/**
 * @description Can be swapped with the primary gray color.
 */

const grayTrue = {
  25: "#FCFCFC",
  50: "#FAFAFA",
  100: "#F5F5F5",
  200: "#E5E5E5",
  300: "#D6D6D6",
  400: "#A3A3A3",
  500: "#737373",
  600: "#525252",
  700: "#424242",
  800: "#292929",
  900: "#141414",
  950: "#0F0F0F",
};

export default grayTrue;
